import { Get2 } from "@/js/api/classroomApi";

interface LastSessionResponse {
	lastEndTime: number;
}

export const fetchLastSessionEndTime: (teacherStableId: string, classroomStableId: string) => Promise<LastSessionResponse> = async (
	teacherStableId: string,
	classroomStableId: string
) => {
	return await Get2<LastSessionResponse>(`v2/teachers/${teacherStableId}/classrooms/${classroomStableId}/last-end-time`);
};
